import * as React from 'react';
function Loading() {
    return React.createElement("div", { className: "tc" }, "Loading...");
}
export default Loading;
//# sourceMappingURL=index.js.map